import getMondaySeconds from "./getMondaySeconds";

export const getDayIndexFromSeconds = (seconds: number) => {
  const mondaySeconds = getMondaySeconds(seconds);
  const secondsDifference = seconds - mondaySeconds;
  const daysDifference = secondsDifference / 86400;
  return daysDifference;
};
